import axios from 'utility/axios'
import {
	GET_PLANS,
	GET_MEMBERSHIP_PRICE_DETAILS,
	POST_ADD_OR_RENEW_PROPERTY_PRICE_DETAILS,
} from 'utility/endpoints'

// Either groupId or partnerSlug is required
export const fetchPlans = async ({ groupId, partnerSlug }) => {
	const path = GET_PLANS()
	console.log('groupId', groupId)
	console.log('partnerSlug', partnerSlug)
	const res = await axios.post(path, {
		groupId,
		partnerSlug,
	})
	console.log('res?.data', res?.data)
	return res?.data
}

export const fetchMembershipPrice = async ({ groupId, planId }) => {
	const path = GET_MEMBERSHIP_PRICE_DETAILS({
		groupId,
		planId,
	})
	const res = await axios.get(path)
	return res?.data
}

export const fetchAddOrRenewPriceDetails = async ({
	groupId,
	planId,
	propTagsToBeAdded,
	propTagsToBeRenewed,
}) => {
	const path = POST_ADD_OR_RENEW_PROPERTY_PRICE_DETAILS
	const res = await axios.post(path, {
		groupId,
		planId,
		propTagsToBeAdded,
		propTagsToBeRenewed,
	})
	return res?.data
}
